module.exports = __webpack_public_path__ + "img/icon-clock.799b6504.svg";